import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {OlOutletContentTypeBaseComponent} from "../ol-outlet-content-type-base.component";

@Component({
    selector: 'ol-outlet-content-type-full',
    templateUrl: 'ol-outlet-content-type-full.component.html',
    standalone: false
})
export class OlOutletContentTypeFullComponent extends OlOutletContentTypeBaseComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized


    ngOnInit(): void {
        super.ngOnInit();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
